import { useEffect, useState } from "react";
import { apiClient } from "src/api/apiService";
import { Contact } from "../Form/types";

export const useSiteSupervisorName = (
  siteSupervisor: string | undefined,
  msaNumber: string | undefined
) => {
  const [siteSupervisorName, setSiteSupervisorName] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [phone, setPhone] = useState<string>("");

  useEffect(() => {
    const fetchPlumbers = async () => {
      if (!msaNumber || !siteSupervisor) return;

      const { data } = await apiClient.get<Contact[]>(`/contact/${msaNumber}`, {
        params: { type: "SUPERVISOR" },
      });
      const supervisor = data.find((c) => c.id === siteSupervisor);
      if (supervisor) {
        const name = `${supervisor.first_name} ${supervisor.last_name}`;
        setSiteSupervisorName(name);
        setFirstName(supervisor.first_name || "");
        setLastName(supervisor.last_name || "");
        setEmail(supervisor.email || "");
        setPhone(supervisor.phone_number || "");
      } else {
        setSiteSupervisorName("");
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");
      }
    };

    fetchPlumbers();
  }, [siteSupervisor, msaNumber]);

  return {
    siteSupervisorName,
    firstName,
    lastName,
    email,
    phone,
  };
};
